import { render, staticRenderFns } from "./BusinessClosed.vue?vue&type=template&id=7f9f1e1a&scoped=true&"
import script from "./BusinessClosed.vue?vue&type=script&lang=js&"
export * from "./BusinessClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9f1e1a",
  null
  
)

export default component.exports